// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"dcd74691","364":"d5dfdd33","411":"16ae7459","417":"94ca1803","537":"5dbe920d","573":"2221638a","748":"396d5883","850":"0d85f146"}[chunkId] + ".chunk.js";
};